'use client'
import { InfoWarningIcon } from '../../../icons'
import React, { ReactNode } from 'react'
import { EmptyState } from '../../../atoms'

export interface DataListEmptyStateProps {
    state: 'empty' | 'error'
    title?: ReactNode
    text?: ReactNode
}

const DEFAULT_TITLES = {
    EMPTY: 'No results found',
    ERROR: 'An error occurred',
}

const DEFAULT_TEXTS = {
    EMPTY: 'Please try again',
    ERROR: 'Please try again',
}

export const DataListEmptyState = ({ state, title, text }: DataListEmptyStateProps): JSX.Element => {
    const getTitle = (): ReactNode => title ?? (state === 'empty' ? DEFAULT_TITLES.EMPTY : DEFAULT_TITLES.ERROR)
    const getText = (): ReactNode => text ?? (state === 'empty' ? DEFAULT_TEXTS.EMPTY : DEFAULT_TEXTS.ERROR)

    return (
        <EmptyState
            title={getTitle()}
            icon={state === 'error' ? <InfoWarningIcon /> : undefined}
            direction="vertical"
            boxed={false}
        >
            <>{getText()}</>
        </EmptyState>
    )
}
